export default "__VITE_ASSET__Dn62cK6e__"